import { getCooperlyAppBaseUrl } from "@/lib/app-base-url";

/**
 * Instant Scan entry points on the homepage: the hero tool buttons, the floating pill and the
 * section that replaces Guided rollout. Each tool button opens the app's scan start page
 * (`/scan/{provider}/start`, its Terms step), which then sends the visitor to the tool's OAuth.
 *
 * Off unless NEXT_PUBLIC_INSTANT_SCAN_ENTRY_ENABLED=true at build time; see docs/development.md.
 */
export function isInstantScanEntryEnabled(
  value: string | undefined = process.env.NEXT_PUBLIC_INSTANT_SCAN_ENTRY_ENABLED,
) {
  return value === "true";
}

export const instantScanProviders = [
  { slug: "clickup", name: "ClickUp" },
  { slug: "linear", name: "Linear" },
  { slug: "asana", name: "Asana" },
  { slug: "notion", name: "Notion" },
] as const;

export type InstantScanProvider = (typeof instantScanProviders)[number];
export type InstantScanProviderSlug = InstantScanProvider["slug"];

/** Where on the homepage a scan starts; becomes `utm_content` and part of `acquisition_cta_id`. */
export const instantScanPlacements = ["hero", "pill", "step", "panel"] as const;
export type InstantScanPlacement = (typeof instantScanPlacements)[number];

export function instantScanCtaId(placement: InstantScanPlacement) {
  return `home_scan_${placement}`;
}

// The app keeps only its known attribution keys (utm_*, acquisition_cta_id, acquisition_source).
export function buildInstantScanStartHref(
  provider: InstantScanProviderSlug,
  placement: InstantScanPlacement,
) {
  const url = new URL(`${getCooperlyAppBaseUrl()}/scan/${provider}/start`);
  url.search = new URLSearchParams({
    utm_source: "cooperly_ai_site",
    utm_medium: "website",
    utm_campaign: "instant_scan",
    utm_content: placement,
    acquisition_source: "site",
    acquisition_cta_id: instantScanCtaId(placement),
  }).toString();
  return url.toString();
}
